import { ELEMENT_CONSTANTS } from './iframe-elements-contants';
import {
  setSettings,
  showMobileChat,
  setSiteColors,
  getColorValues,
  messageHandlers,
} from '../santa-handlers/santa-handlers';
import { isMobile } from 'is-mobile';

function generateIframeContainer(isLeftPosition) {
  const iframeContainer = document.createElement('div');
  iframeContainer.style.cssText = `min-height: 90px; width: 376px; z-index: 50; height: 90px; position: fixed; top: auto; left: ${
    isLeftPosition ? '0px' : 'auto'
  }; right: ${!isLeftPosition ? '0px' : 'auto'}; bottom: 0px; border: 0; ${
    isMobile() && 'display: none;'
  }`;
  iframeContainer.id = ELEMENT_CONSTANTS.CONTAINER_ID;

  return iframeContainer;
}

function chatSrc(instance, host) {
  const urlEncodedHost = encodeURIComponent(host);
  return `https://engage.wixapps.net/chat-widget-server/renderChatWidget/index?cacheKiller=1531654646091&compId=comp-test&deviceType=${
    isMobile() ? 'mobile' : 'desktop'
  }&fullRender=true&height=549&instance=${instance}&locale=${messageHandlers.getLocale()}&viewMode=standalone&width=376&host=${urlEncodedHost}&disableAutoMessages`;
}

function generateChatIframe(iframeSrc) {
  const iframe = document.createElement('iframe');
  iframe.name = ELEMENT_CONSTANTS.IFRAME_NAME;
  iframe.id = ELEMENT_CONSTANTS.IFRAME_ID;
  iframe.title = ELEMENT_CONSTANTS.IFRAME_TITLE;
  iframe.style.cssText = ELEMENT_CONSTANTS.IFRAME_CSS;
  iframe.src = iframeSrc;

  return iframe;
}

export const generateChatElement = ({
  instance,
  chatData,
  siteColors,
  url,
  host,
}) => {
  setSettings(chatData);
  setSiteColors(siteColors);
  const isLeftPosition =
    chatData && chatData.layout && chatData.layout.position === '2';
  const iframeContainer = generateIframeContainer(isLeftPosition);
  const iframeUrl = instance ? chatSrc(instance, host) : url;
  if (!iframeUrl) {
    return null;
  }
  const iframe = generateChatIframe(iframeUrl);
  iframeContainer.appendChild(iframe);

  return iframeContainer;
};

export const generateQABElement = () => {
  const { primaryColor, headerTextColor } = getColorValues();
  const QABElementContainer = document.createElement('div');
  QABElementContainer.style.cssText = `
  position: fixed;
  bottom: 20px;
  right: 20px;
  `;

  const QABElementWrapper = document.createElement('div');
  QABElementWrapper.style.cssText = `
  background-color: ${primaryColor.value};
  position: relative;
  box-sizing: border-box;
  height: 60px;
  width: 60px;
  padding-top: 1px;
  box-shadow: 0 0 4px 0 rgba(22, 45, 61, .25);
  border-radius: 50%;`;

  QABElementContainer.appendChild(QABElementWrapper);
  const QABElementButton = document.createElement('button');
  QABElementButton.style.cssText = `
    width: 60px;
    height: 60px;
    background-color: transparent;
    color: inherit;
    border: 0;
    outline: none;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    padding-top: 4px;
  `;

  QABElementWrapper.appendChild(QABElementButton);
  const QABElement = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'svg',
  );
  QABElement.style.cssText = `
  width: 26px;
  height: 26px;`;

  QABElementButton.appendChild(QABElement);

  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute(
    'd',
    'M22.81 9.41a11.49 11.49 0 1 0-7.47 12.93.47.47 0 0 1 .3 0l3.05 1a1 1 0 0 0 1.3-1v-2.92a.48.48 0 0 1 .13-.32 11.63 11.63 0 0 0 1.3-1.79 11.47 11.47 0 0 0 1.39-7.9zM7.5 12.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm4 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm4 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1z',
  );
  path.setAttribute('fill', headerTextColor.value);
  QABElement.appendChild(path);

  QABElementContainer.addEventListener('touchend', showMobileChat);

  return QABElementContainer;
};
